import { useApiGet } from 'hooks/useApi';
import { Operator } from '../../../../../models/Operator';

type OperatorListProps = {
  ddd?: string | null;
};

const useControllerOperatorLis = ({ ddd }: OperatorListProps) => {
  const { data: operadoras, isLoading } = useApiGet<Operator[]>(
    '/recharge/operators',
    {
      params: { area_code: ddd },
      enabled: !!ddd
    }
  );
  return { operadoras, isLoading };
};

export default useControllerOperatorLis;
